import { defineComponent, onMounted, onUnmounted, reactive } from '@vue/composition-api';
export default defineComponent({
    setup(props, context) {
        let $ = reactive({
            int: null,
            show: false
        });
        // =================
        //
        // mounted
        //
        onMounted(() => {
            $.int = setInterval(() => {
                $.show = window.scrollY >= 1;
            }, 500);
        });
        onUnmounted(() => {
            if ($.int) {
                clearInterval($.int);
            }
        });
        // =================
        //
        // methods
        //
        let toTop = () => {
            window.scrollTo(0, 0);
        };
        // =================
        //
        // done
        //
        return {
            $,
            toTop
        };
    }
});
